import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, DropdownButton, Dropdown } from "react-bootstrap";
import {
  qcComplete,
  qcReject,
  qcSendBack,
  qcRejectReallocation,
  qcgetRemark,
  dataAllocationCompany,
  processingSubmit,
} from "../../../../middleware/services/cmsApi";

import { actionSuccess, actionError } from "../../../../middleware/actions/utilityAction";
import { showAlertBox } from "../../../../middleware/actions/alertBoxAction";
import { setClickSaveSubmitState, setOverviewUpdateStatus } from "../../../../middleware/actions/companyAction";
import RemarkUI from "./remarkModal";
import { getLoggedInUser, accessRightActionCheck } from "../../../../utilities";
import RejectRemarkModal from "../rejectRemark";
import PublishingActionButton from "../../dataPublishing/company/actionButton";
import { COMMON_ACCESS_ACTION } from "../../../../constants";

// Qc actions component
const QcCompanyActions = (props) => {
  const loggedInUser = getLoggedInUser();
  const dispatch = useDispatch();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [rejectRemark, setRejectRemark] = useState(false);
  const [isCompleteReject, setCompleteReject] = useState(false);
  const [remarkCount, setRemarkCount] = useState([]);
  const updateStatus = useSelector((state) => state.companyState.updateStatus);
  const clickStatus = useSelector((state) => state.companyState.clickStatus);
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  /* Common access */
  const accessPermissionRemark = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.REMARKS);
  const accessPermissionQCComplete = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.QC_COMPLETE);
  const accessPermissionSendBack = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SEND_BACK);
  const accessPermissionReject = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.REJECT);
  const accessPermissionDataPublishing = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.PUBLISH);
  const accessActionSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SUBMIT);

  /* Interface actions */
  useEffect(() => {
    const interfaceName = "Basic";
    let actionAccess = accessRightActionCheck("Quality Check", interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, []);

  //reject a record
  const handleReject = (data) => {
    const payload = {
      userId: loggedInUser._id,
      rejectRemark: data.rejectRemark,
    };
    dispatch(
      showAlertBox({
        okCallback: () => {
          qcReject(props.companyId, payload)
            .then((response) => {
              dispatch(actionSuccess("Qc record rejected completly successfully"));
              dataAllocationCompany(loggedInUser._id);
              history.push("/data-qc/company");
            })
            .catch((err) => {
              dispatch(actionError(err.data.message || "Something went wrong"));
            });
        },
      })
    );
  };

  const handleRejectAndReallocate = (data) => {
    const payload = {
      userId: loggedInUser._id,
      rejectRemark: data.rejectRemark,
    };
    dispatch(
      showAlertBox({
        okCallback: () => {
          qcRejectReallocation(props.companyId, payload)
            .then((response) => {
              dispatch(actionSuccess("Qc record rejected and reallocated successfully"));
              history.push("/data-qc/company");
              dataAllocationCompany(loggedInUser._id);
            })
            .catch((err) => {
              dispatch(actionError(err.data.message || "Something went wrong"));
            });
        },
      })
    );
  };

  // fetch previous added remark
  const fetcQcRemarkSpecificToCompany = () => {
    qcgetRemark(props.companyId).then((response) => {
      if (response) setRemarkCount(response.data.data);
    });
  };

  useEffect(() => {
    fetcQcRemarkSpecificToCompany();
  }, []);

  useEffect(() => {
    if (updateStatus) {
      dispatch(
        showAlertBox({
          okCallback: async () => {
            processingSubmit(props.companyId, "basic", { userId: loggedInUser._id })
              .then((response) => {
                dispatch(actionSuccess(`Company successfully Saved & Submitted`));
                dispatch(setClickSaveSubmitState());
                dispatch(setOverviewUpdateStatus());
              })
              .catch((err) => {
                console.log(err.data.message);
                dispatch(actionError(err.data.message || "Something went wrong"));
              });
          },
        })
      );
    }
  }, [updateStatus, props.companyId]);

  return (
    <>
      <div className="form-submit-box" style={{ overflow: "inherit" }}>
        <div className="container-fluid nopadding">
          <div className="row">
            <div className="float-LEFT col-md-1 text-left">
              {props.selectedIndex > -1 ? (
                <span className="pl-4" style={{ marginLeft: "-3em" }}>
                  <span className="span-link">
                    <button
                      type="button"
                      className="cy-next-btn btn btn-outline-dark cy-btn pl-4 pr-4 mt-1 mb-1"
                      onClick={() => {
                        props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex + 1);
                      }}
                    >
                      Next
                    </button>
                  </span>
                </span>
              ) : null}
            </div>
            <div className="float-right col-md-11 text-right ">
              <Link to="/data-qc/company" className="ml-2">
                <button type="button" className="btn btn-outline-dark cy-btn pl-4 pr-4 mr-3 mt-1 mb-1">
                  Cancel
                </button>
              </Link>
              {accessPermissionRemark ? (
                <button
                  type="button"
                  className="btn btn-outline-danger cy-btn pl-4 pr-4 mr-3 mt-1 mb-1"
                  onClick={() => {
                    setShowModal(!showModal);
                  }}
                >
                  Remarks{remarkCount.length ? `(${remarkCount.length})` : null}
                </button>
              ) : null}

              {/*Qc complete */}
              {accessPermissionQCComplete ? (
                <button
                  type="button"
                  className="btn btn-outline-danger cy-btn pl-4 pr-4 mr-3 mt-1 mb-1"
                  onClick={() => {
                    let payload = {
                      userId: loggedInUser._id,
                    };
                    dispatch(
                      showAlertBox({
                        okCallback: () => {
                          qcComplete(props.companyId, payload)
                            .then((response) => {
                              dispatch(actionSuccess("Qc completed successfully"));
                              history.push("/data-qc/company");
                              dataAllocationCompany(loggedInUser._id);
                            })
                            .catch((err) => {
                              dispatch(actionError(err.data.message || "Something went wrong"));
                            });
                        },
                      })
                    );
                  }}
                >
                  Qc Complete
                </button>
              ) : null}

              {/*Qc send back */}
              {accessPermissionSendBack ? (
                <button
                  type="button"
                  className="btn btn-outline-danger cy-btn mr-3 mt-1 mb-1"
                  onClick={() => {
                    let payload = {
                      userId: loggedInUser._id,
                    };
                    dispatch(
                      showAlertBox({
                        okCallback: () => {
                          qcSendBack(props.companyId, payload)
                            .then((response) => {
                              dispatch(actionSuccess("Qc record sent for rework successfully"));
                              history.push("/data-qc/company");
                              dataAllocationCompany(loggedInUser._id);
                            })
                            .catch((err) => {
                              dispatch(actionError(err.data.message || "Something went wrong"));
                            });
                        },
                      })
                    );
                  }}
                >
                  Send Back
                </button>
              ) : null}
              {/*Qc reject  complete*/}
              {accessPermissionReject ? (
                <ButtonGroup className="mt-1 mb-1">
                  <DropdownButton title="Reject" id="bg-nested-dropdown" className="cy-btn">
                    <Dropdown.Item
                      eventKey="1"
                      onClick={() => {
                        setRejectRemark(!rejectRemark);
                        setCompleteReject(true);
                      }}
                    >
                      Reject Completely
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="2"
                      onClick={() => {
                        setCompleteReject(false);
                        setRejectRemark(!rejectRemark);
                      }}
                    >
                      Reject & Allocate
                    </Dropdown.Item>
                  </DropdownButton>
                </ButtonGroup>
              ) : null}
              {accessActionSubmit ? (
                <button
                  type="button"
                  className="btn btn-primary cy-btn pl-2 pr-2 ml-3 mt-1 mb-1"
                  onClick={() => {
                    if (clickStatus) dispatch(setClickSaveSubmitState());
                    if (updateStatus) dispatch(setOverviewUpdateStatus());
                    dispatch(setClickSaveSubmitState(true));
                  }}
                >
                  Submit
                </button>
              ) : null}
              {accessPermissionDataPublishing ? <PublishingActionButton companyId={props.companyId} {...history} /> : null}
            </div>
          </div>
        </div>
      </div>
      <RemarkUI
        companyId={props.companyId}
        userId={loggedInUser._id}
        showModal={showModal}
        remarks={remarkCount}
        clicked={() => {
          setShowModal(!showModal);
          fetcQcRemarkSpecificToCompany();
        }}
      />
      <RejectRemarkModal
        showModal={rejectRemark}
        clicked={(data) => {
          if (isCompleteReject && data) {
            handleReject(data);
          }
          if (!isCompleteReject && data) {
            handleRejectAndReallocate(data);
          }
          setRejectRemark(!rejectRemark);
        }}
      />
    </>
  );
};

export default QcCompanyActions;
